import useSaifFetch from "../hooks/useSaifFetch";
import { useContext, useEffect, useState } from "react";
import React from 'react';

import { API_ACTION, SaifFetch } from "../Utils/SaifFetch";
import { ICollection } from "../Models/ICollections";
import RequestContext from "../Context/RequestContext";
import { IRequestTools } from "../Models/IUser";

const PermissionMappings = () => {

    const [shouldRefetch, refetch] = useState({});
    const {
    data,
    loading: loadingCollections,
    error,
    status,
  } = useSaifFetch<ICollection[]>(API_ACTION.getPermissionMappings, shouldRefetch, SaifFetch.get);

  const { setCollections, collections, createPermMappingDict } = useContext(RequestContext) as IRequestTools;

  useEffect(() => {
    if (status && status >= 400) {
        console.log('Error fetching permission collections');
    }
    else if (status && data) {
        setCollections(data);
    }
  }, [status]);

  useEffect(() => {

    console.log('collections' || collections)
    if (Object.keys(collections).length !== 0) {
        createPermMappingDict();
    }
  }, [collections]);

  useEffect(() => {
    refetch({default: true});
  }, []);

  return (
    <></>
  );
}

export default PermissionMappings;